import { render, staticRenderFns } from "./UnderstandingYou.vue?vue&type=template&id=619fe0ac&"
import script from "./UnderstandingYou.vue?vue&type=script&lang=js&"
export * from "./UnderstandingYou.vue?vue&type=script&lang=js&"
import style0 from "./UnderstandingYou.vue?vue&type=style&index=0&id=619fe0ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports